import GET_PROPERTIES from "./getProperties";

export default {
  GET_PROPERTIES,
};
